import styled from "styled-components"

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${(props) => props.theme.colors.primaryBlue};
  height: 36px;
  border-radius: 10px;
  border: 0;
  color: white;
  width: 100%;
  font-weight: 500;
  transition: background-color 0.2;

  &:hover {
    background: ${(props) => props.theme.colors.secondaryBlue};
  }

  &:disabled {
    background: #b0b0b0;
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:disabled:hover {
    background: #b0b0b0;
  }
`
